// /app/frontend/src/components/frugal-v2/sections/SavingsSection.jsx
// Savings section with separate add form and list collapse (100 lines)

import React, { useState } from 'react';
import { PiggyBank } from 'lucide-react';
import CollapsibleSection from '../components/CollapsibleSection';
import ListItem from '../components/ListItem';
import AddItemForm from '../components/AddItemForm';
import EditItemModal from '../components/EditItemModal';
import { SAVING_CATEGORIES } from '../constants/categories';

const SavingsSection = ({ savings = [], onAdd, onToggle, onEdit, onDelete, fundingStatus, t }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const total = savings.reduce((sum, s) => sum + (s.amount || 0), 0);
  const saved = savings
    .filter(s => s.is_paid)
    .reduce((sum, s) => sum + (s.amount || 0), 0);

  const subtitle = `${t('frugal.savings.saved')}: $${saved.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const handleSaveEdit = async (id, data) => {
    if (onEdit) await onEdit(id, data);
    setEditingItem(null);
  };

  const addFormComponent = (
    <AddItemForm
      type="saving"
      onAdd={async (data) => {
        await onAdd(data);
        setShowForm(false);
      }}
      onCancel={() => setShowForm(false)}
      colorClass="bg-sky-500 hover:bg-sky-600"
      showCategory={true}
      categories={SAVING_CATEGORIES}
      t={t}
    />
  );

  return (
    <>
      <CollapsibleSection
        icon={PiggyBank}
        title={t('frugal.savings.title')}
        total={total}
        subtitle={subtitle}
        iconColorClass="text-sky-400"
        showAddForm={showForm}
        onToggleAddForm={() => setShowForm(!showForm)}
        addForm={addFormComponent}
        defaultExpanded={false}
        fundingStatus={fundingStatus}
      >
        {/* List */}
        <div className="space-y-2">
          {savings.length === 0 ? (
            <p className="text-slate-500 text-sm text-center py-4">{t('frugal.savings.empty')}</p>
          ) : (
            savings.map(saving => (
              <ListItem
                key={saving.id}
                item={saving}
                colorClass="text-sky-400"
                onToggle={onToggle}
                onEdit={onEdit ? setEditingItem : undefined}
                onDelete={onDelete}
                showMenu={!!onEdit}
                t={t}
              />
            ))
          )}
        </div>
      </CollapsibleSection>

      {/* Edit Modal */}
      {editingItem && (
        <EditItemModal
          item={editingItem}
          type="saving"
          onSave={handleSaveEdit}
          onDelete={onDelete}
          onClose={() => setEditingItem(null)}
          showCategory={true}
          categories={SAVING_CATEGORIES}
          t={t}
        />
      )}
    </>
  );
};

export default SavingsSection;
